import React, { useState } from "react";
import {
  Modal,
  Button,
  Card,
  Container,
  Row,
  Col,
  Pagination,
  Form,
} from "react-bootstrap";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";

// Konfigurasi worker PDF.js
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const datahewan = [
  {
    nama: "Jurnal Ilmiah",
    file: "pdf/Publikasi_Publik_Jurnal_Ilmiah.pdf",
  },
  {
    nama: "Working Paper ISSN 2024",
    file: "pdf/2024_e.d. Publikasi Publik - Working Paper ISSN 2024.pdf",
  },
  
];

function PublikasiFile() {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const dataPerPage = 12;

  const filteredData = datahewan.filter((item) => {
    const term = searchTerm.toLowerCase();
    return (
      item.nama.toLowerCase().includes(term)
    );
  });

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = filteredData.slice(indexOfFirstData, indexOfLastData);
  const totalPages = Math.ceil(filteredData.length / dataPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const onDocumentLoadSuccess = ({ numPages }) => setNumPages(numPages);

  return (
    <Container className="mt-4">
      <h3 className="text-center mb-3">Publikasi File</h3>

      {/* Search */}
      <Form className="mb-4">
        <Form.Control
          type="text"
          placeholder="Cari berdasarkan nama umum, nama ilmiah, atau famili..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
        />
      </Form>

      {/* Grid */}
      <Row>
        {currentData.length > 0 ? (
          currentData.map((item, index) => (
            <Col key={index} md={3} sm={6} className="mb-4">
              <Card className="h-100 shadow-sm">
                <div
                  onClick={() => setSelectedPdf(item.file)}
                  style={{
                    cursor: "pointer",
                    height: "250px",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#f8f9fa",
                  }}
                >
                  {/* ==== Hanya tampil halaman pertama PDF ==== */}
                  <Document file={item.file} onLoadSuccess={onDocumentLoadSuccess}>
                    <Page pageNumber={1} width={220} />
                  </Document>
                </div>
                <Card.Body>
                  <Card.Title className="text-center">{item.nama}</Card.Title>
                  <Card.Text style={{ fontSize: "0.9rem" }}>
                    <strong>Nama File:</strong> {item.nama} <br />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))
        ) : (
          <Col>
            <p className="text-center text-muted mt-4">Tidak ada hasil ditemukan.</p>
          </Col>
        )}
      </Row>

      {/* Pagination */}
      <div className="d-flex justify-content-center mt-3">
        <Pagination>
          {[...Array(totalPages)].map((_, index) => (
            <Pagination.Item
              key={index + 1}
              active={index + 1 === currentPage}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
          ))}
        </Pagination>
      </div>

      {/* Modal PDF full */}
      <Modal
  show={!!selectedPdf}
  onHide={() => setSelectedPdf(null)}
  size="xl"
  centered
  scrollable
>
  <Modal.Header closeButton>
    <Modal.Title>Lihat Dokumen Lengkap</Modal.Title>
  </Modal.Header>
  <Modal.Body
    style={{
      textAlign: "center",
      backgroundColor: "#f4f4f4",
      padding: "20px",
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Document
        file={selectedPdf}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<p>Memuat dokumen...</p>}
      >
        {Array.from(new Array(numPages), (el, index) => (
          <div
            key={index}
            style={{
              marginBottom: "30px",
              display: "flex",
              justifyContent: "center",
            }}
          >
		  
            <Page
              pageNumber={index + 1}
              width={Math.min(window.innerWidth * 0.8, 900)} // dinamis
              renderAnnotationLayer={false}
              renderTextLayer={false}
            />
          </div>
        ))}
      </Document>
    </div>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setSelectedPdf(null)}>
      Tutup
    </Button>
  </Modal.Footer>
</Modal>
    </Container>
  );
}

export default PublikasiFile;
